export default __webpack_public_path__ + "navigation-camera-pitch-near-maneuver-disabled-960-5c1f2707f59e8f819190aeab7799e899.png";